module.exports = __webpack_public_path__ + "images/stickers/thumbsup@2x.6f6cea3566b6fbbc0067.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/thumbsup@2x.png
// module id = /NY6
// module chunks = 1